export default function Footer() {
  return (
    <footer className="bg-[#0E0503] text-white pt-10 sm:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">

        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 pb-8 sm:pb-12 border-b border-white/10">

          {/* Brand column */}
          <div>
            <p className="text-sm sm:text-base font-bold text-[#E48523] mb-3 tracking-wide uppercase leading-snug">
              Indigenous Engagement and Facilitation Pty Ltd
            </p>
            <p className="text-sm text-white/60 leading-relaxed">
              Building cultural capability across Australian organisations through evidence-based, practitioner-led training.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm sm:text-base">Quick Links</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="/course-overview" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Course Overview
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Contact details */}
          <div>
            <p className="text-sm font-semibold text-white/80 uppercase tracking-widest mb-4">
              Contact Us
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-mail-line text-[#E48523]"></i>
                </span>
                <a
                  href="mailto:info@indigenousfacilitation.com.au"
                  className="text-sm text-white/70 hover:text-[#E48523] transition-colors break-all"
                >
                  info@indigenousfacilitation.com.au
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-[#E48523]"></i>
                </span>
                <span className="text-sm text-white/70">
                  Australia
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-time-line text-[#E48523]"></i>
                </span>
                <span className="text-sm text-white/70">
                  Response within 1 business day
                </span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-6 sm:pt-8 flex flex-col items-center md:flex-row md:justify-between gap-3 sm:gap-4">
          <div className="flex flex-col items-center md:items-start gap-1 text-center md:text-left">
            <p className="text-xs text-white/40 leading-relaxed">
              © 2025 Indigenous Engagement &amp; Facilitation Pty Ltd.
              <span className="hidden sm:inline"> All rights reserved.</span>
            </p>
            <p className="text-xs text-white/30">
              ABN: 51 669 512 823 &nbsp;|&nbsp; ACN: 669 512 823
            </p>
          </div>
          <div className="flex items-center gap-3 text-sm text-gray-400 flex-shrink-0">
            <a href="/privacy-policy" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
            <span className="text-white/20">|</span>
            <a href="/terms" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Terms of Service
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
